import { ActionsOf } from '../../../helpers/actions';
import { getType } from 'typesafe-actions';
import * as siteActions from './actions';
import produce from 'immer';
import { Site } from '../../../models';
import { Normalized } from '../../../helpers/norm';

export interface SiteNorm
  extends Normalized<Site, 'nodes' | 'tags', { nodeIds: number[]; tagIds: string[] }> {}

export interface SiteEntityState {
  byId: { [Key: number]: SiteNorm };
  statusById: { [Key: number]: string };
  settings: { [Key: number]: Site };
  lastQueryTime: { [Key: number]: string }; // Timestamp of the last query
}

export interface SiteStateSlice {
  entities: {
    site: SiteEntityState;
  };
}

export const initialState = {
  byId: {},
  statusById: {},
  settings: {},
  lastQueryTime: {},
};

type SiteActions = ActionsOf<typeof siteActions>;

export const siteEntityReducer = produce((draft: SiteEntityState, action: SiteActions) => {
  switch (action.type) {
    case getType(siteActions.fetchSiteData.success): {
      const { site } = action.payload.result;
      draft.byId[site.id] = site;
      // Register the timestamp of the last successful query
      draft.lastQueryTime[site.id] = new Date().toISOString();
      break;
    }

    case getType(siteActions.getSiteSettings.success): {
      const site = action.payload.result as unknown as Site;
      draft.settings[site.id] = site;
      // Register the timestamp of the last successful query of settings
      draft.lastQueryTime[site.id] = new Date().toISOString();
      break;
    }

    default:
      break;
  }
}, initialState);
